import React from "react";
import PropTypes from "prop-types";
import { FaEdit } from "react-icons/fa";
import CommonModal from "./CommonModal";
import {
  agreementTexts,
  identityText,
  onboardingStepData
} from "../../locales/en";
import Style from "./modal.module.scss";
import { MAX_CALL_COUNT } from "../../utils/constants/appConstants";

const AgreementModal = ({
  isOpen,
  toggle,
  handleAnnatureCheckStatus,
  setIsDisabledButton,
  anatureDataUrl,
  loading,
  error
}) => {
  const handleCloseButton = () => {
    toggle();
    let callCount = 0;
    setIsDisabledButton(true);
    const scheduleNextCall = (delay) => {
      setTimeout(() => {
        callCount++;
        handleAnnatureCheckStatus();
        setIsDisabledButton(false);
        if (callCount < MAX_CALL_COUNT) {
          scheduleNextCall(5000);
        }
      }, delay);
    };
    scheduleNextCall(10000);
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={handleCloseButton}
      title={
        <>
          <FaEdit className="me-2" /> {agreementTexts?.modal?.title}
        </>
      }
      backDrop
      modalClassName={`${Style.agreementModal} modal-xl agreementmodal-wrap`}
      headerClassName={`${Style.agreementModalHeader} modal-close-black`}
      bodyClassName={`${Style.agreementModalContent} modal-content embed-responsive embed-responsive-16by9`}
      hideFooter
    >
      {loading ? (
        <div className="spinner-wrap bg-light loaderposition">
          <div className="snipper-wrap">
            <div className="spinner-border custom-spinner-color" />
            <h3>{identityText.onboardingIntgModal.thismayTake}</h3>
          </div>
        </div>
      ) : (
        <>
          {error && (
            <p className="text-danger text-center m-3">
              <strong>{error}</strong>
            </p>
          )}
          {anatureDataUrl && (
            <iframe
              title={onboardingStepData.agreement}
              id="annatureIframe"
              className="embed-responsive-item"
              src={anatureDataUrl}
              allowFullScreen
            />
          )}
        </>
      )}
    </CommonModal>
  );
};

AgreementModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handleAnnatureCheckStatus: PropTypes.func,
  setIsDisabledButton: PropTypes.func,
  anatureDataUrl: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default AgreementModal;
